/* ==========================================================================
   OTOMAX GARAGE WORKSHOP INTERACTIVE SCRIPTS (Accordion & Smooth Scroll)
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {
  // Accordion Logic for FAQ
  const faqButtons = document.querySelectorAll('.og-fitment-faq-button');
  
  faqButtons.forEach(button => {
    button.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      // Toggle current item
      this.setAttribute('aria-expanded', !isExpanded);
      const answer = document.getElementById(this.getAttribute('aria-controls'));
      if (answer) {
        answer.style.display = isExpanded ? 'none' : 'block';
      }
    });

    // Keyboard navigation (Enter / Space)
    button.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // Smooth Scroll for Internal Anchor Links
  const internalLinks = document.querySelectorAll('.og-fitment-wrapper a[href^="#"]');
  internalLinks.forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId && targetId !== '#') {
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
});
